
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetolonavala() {



    const cardData =
    {
        keyword: 'Pune to Lonavala - Khandala Cab',
        heading: 'Mauli Cabs:  Pune to Lonavala - Khandala Cab',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune to Lonavala - Khandala cab services, making your trip to these picturesque hill stations hassle-free. Whether you are visiting for a quick getaway, a family outing, or a relaxing retreat, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, no hidden charges, and transparent pricing, Mauli Cabs ensures you a comfortable and safe journey between Pune, Lonavala, and Khandala.',

        top: 'Top Places to Visit in Lonavala with Mauli Cabs',

"topPlaces": [
    {
        "title": "Bhushi Dam",
        "description": "Bhushi Dam is one of Lonavala’s most popular attractions, especially during the monsoon season. The dam, surrounded by lush greenery, offers a picturesque view and is a great spot for picnics and water activities."
    },
    {
        "title": "Lonavala Lake",
        "description": "Lonavala Lake is a serene spot surrounded by hills, offering a peaceful environment for nature lovers. It is ideal for quiet walks and offers beautiful views of the surrounding hills and valleys."
    },
    {
        "title": "Tiger's Leap",
        "description": "Tiger's Leap is a scenic viewpoint offering a panoramic view of the lush green valley below. It is named for the resemblance of a tiger leaping into the valley. The view from the top is breathtaking and perfect for photography."
    },
    {
        "title": "Karla Caves",
        "description": "Karla Caves are ancient rock-cut Buddhist caves located near Lonavala. The caves are known for their intricate architecture, ancient sculptures, and the massive Chaitya Hall, making it a fascinating spot for history enthusiasts."
    },
    {
        "title": "Pawna Lake",
        "description": "Pawna Lake is a beautiful artificial lake surrounded by mountains, making it a popular destination for camping, picnics, and water sports. The serene atmosphere and stunning views make it a perfect weekend getaway."
    },
    {
        "title": "Rajmachi Fort",
        "description": "Rajmachi Fort is a historic fort situated amidst the scenic Sahyadri ranges. It offers a perfect trekking opportunity for adventure lovers and provides stunning views of the surrounding valleys and waterfalls."
    },
    {
        "title": "Della Adventure Park",
        "description": "Della Adventure Park is an adventure lover’s paradise, offering a range of activities like go-karting, zip-lining, dirt biking, and more. It’s an ideal place for family fun and adrenaline-filled experiences."
    },
    {
        "title": "Tungarli Lake",
        "description": "Tungarli Lake is a peaceful spot situated between the hills of Lonavala. Surrounded by scenic views and lush greenery, it offers a relaxing atmosphere, perfect for nature walks and photography."
    },
    {
        "title": "Lion’s Point",
        "description": "Lion’s Point is a popular viewpoint offering magnificent views of the surrounding hills and valleys. It is especially famous for its breathtaking sunset views and is a must-visit for anyone exploring Lonavala."
    },
    {
        "title": "Bushy Dam Waterfall",
        "description": "Located near Bhushi Dam, the Bushy Dam Waterfall is a popular attraction during the monsoon season. The waterfall, cascading over the rocks, creates a refreshing and scenic atmosphere, perfect for a cool escape."
    }
],

"services": [
    {
        "name": "Pune to Lonavala - Khandala Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services for your journey from Pune to Lonavala and Khandala. Whether for a quick getaway or a sightseeing trip, we ensure a smooth and pleasant ride."
    },
    {
        "name": "Book Pune to Lonavala - Khandala Taxi",
        "description": "Book your taxi from Pune to Lonavala - Khandala with Mauli Cabs. Our fleet of well-maintained vehicles ensures a comfortable and hassle-free ride to these beautiful hill stations."
    },
    {
        "name": "Affordable Pune to Lonavala - Khandala Cab",
        "description": "Mauli Cabs provides affordable and reliable taxi services for your journey from Pune to Lonavala - Khandala, ensuring you get the best value for your trip without compromising on comfort."
    },
    {
        "name": "Private Taxi for Lonavala - Khandala from Pune",
        "description": "Choose a private taxi for your journey from Pune to Lonavala - Khandala. Mauli Cabs offers personalized services, ensuring a private and stress-free experience with comfort and convenience."
    },
    {
        "name": "Lonavala - Khandala Trip by Cab from Pune",
        "description": "Plan your trip from Pune to Lonavala - Khandala with Mauli Cabs. Whether for a day trip or a weekend getaway, we ensure a smooth and enjoyable journey with our reliable taxi services."
    },
    {
        "name": "Pune to Lonavala - Khandala One-Way or Round Trip",
        "description": "Mauli Cabs offers flexible one-way or round-trip options for your journey from Pune to Lonavala - Khandala. Choose the option that best suits your schedule and enjoy a hassle-free experience."
    },
    {
        "name": "Lonavala - Khandala Sightseeing by Cab",
        "description": "Explore the beautiful hill stations of Lonavala and Khandala with Mauli Cabs' sightseeing services. Our experienced drivers will guide you through the best spots in both destinations for an unforgettable experience."
    },
    {
        "name": "Group Travel to Lonavala - Khandala",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles that can accommodate your entire group for a comfortable and enjoyable trip from Pune to Lonavala - Khandala."
    },
    {
        "name": "Luxury Taxi for Lonavala - Khandala Trip",
        "description": "Experience luxury travel with Mauli Cabs for your journey from Pune to Lonavala - Khandala. Our fleet of premium vehicles ensures a comfortable and stylish ride to these scenic hill stations."
    },
    {
        "name": "Comfortable Taxi Ride from Pune to Lonavala - Khandala",
        "description": "Mauli Cabs provides a comfortable and reliable taxi ride from Pune to Lonavala - Khandala. Our well-maintained vehicles and professional drivers ensure a smooth journey, allowing you to relax and enjoy your trip."
    }
],

"tableData": [
    ["Pune to Lonavala - Khandala Cab Service", "Book Pune to Lonavala - Khandala Taxi"],
    ["Affordable Pune to Lonavala - Khandala Cab", "Private Taxi for Lonavala - Khandala from Pune"],
    ["Lonavala - Khandala Trip by Cab from Pune", "Pune to Lonavala - Khandala One-Way or Round Trip"],
    ["Lonavala - Khandala Sightseeing by Cab", "Group Travel to Lonavala - Khandala"],
    ["Luxury Taxi for Lonavala - Khandala Trip", "Comfortable Taxi Ride from Pune to Lonavala - Khandala"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we ensure that your Pune to Lonavala - Khandala Cab is punctual and dependable. Whether you're heading to these popular hill stations for a weekend getaway or a day trip, our drivers guarantee on-time pickups and drop-offs, making your journey hassle-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of vehicles is designed for your comfort. From sedans to SUVs and premium cars, all our vehicles for the Pune to Lonavala - Khandala Cab come with spacious interiors, air conditioning, and plenty of legroom, ensuring you have a pleasant journey through the scenic routes."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Mauli Cabs' experienced drivers are well-acquainted with the Pune to Lonavala - Khandala route, ensuring a smooth and safe trip. They know the best routes, local traffic patterns, and are committed to making your journey both enjoyable and secure."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your Pune to Lonavala - Khandala Cab with no hidden charges. We provide transparent pricing so that you know exactly what to expect, allowing you to travel without any concerns about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a smooth, secure, and pleasant ride to Lonavala and Khandala."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "No matter the time, Mauli Cabs is available 24/7 for your Pune to Lonavala - Khandala Cab. Whether it's an early morning departure or a late-night return, our customer service team is always ready to assist with your booking needs."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Lonavala - Khandala Cab with Mauli Cabs is simple and convenient. You can book online through our website or mobile app, or reach out to our customer service team for personalized assistance with your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling for a family vacation, a romantic retreat, or a quick getaway, Mauli Cabs offers customized travel packages for your Pune to Lonavala - Khandala Cab. Tell us your preferences, and we'll tailor your journey to suit your needs."
    }
]






    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Lonavala - Khandala with Mauli Cabs?',
            answer: 'Booking your cab is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Lonavala or Khandala as your destination, then choose the vehicle that fits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Lonavala - Khandala?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that fits your comfort and space requirements for the journey.',
        },
        {
            question: 'Is the fare from Pune to Lonavala - Khandala fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. There are no hidden costs, and you’ll know the total fare upfront.',
        },
        {
            question: 'Can I book a round trip from Pune to Lonavala - Khandala?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we’ll take care of the rest.',
        },
        {
            question: 'How long does the journey from Pune to Lonavala - Khandala take?',
            answer: 'The ride from Pune to Lonavala or Khandala generally takes about 1.5 to 2 hours, depending on traffic and road conditions. We ensure a smooth and timely journey.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Lonavala - Khandala route?',
            answer: 'Yes, our drivers are well-trained, experienced, and familiar with the best routes to ensure a safe and comfortable ride from Pune to Lonavala - Khandala.',
        },
        {
            question: 'Can I book a cab for sightseeing in Lonavala - Khandala?',
            answer: 'Yes, Mauli Cabs offers customized sightseeing tours in Lonavala and Khandala. Whether you want to visit popular tourist spots like the Bhushi Dam or Rajmachi Fort, our drivers will make sure you have a great experience.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are air-conditioned and well-maintained for comfort and cleanliness. We prioritize hygiene to ensure you have a pleasant ride.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Lonavala - Khandala trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and reliable service. Whether it’s a family outing or a weekend getaway, we ensure a comfortable and hassle-free trip to Lonavala and Khandala.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sameer Mehta",
            position: "Weekend Explorer",
            text: "A delightful ride to Lonavala. The driver was polite, the vehicle was clean and comfortable, and we had an amazing time exploring the hill station. Highly recommend Mauli Cabs for such trips!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Sharma",
            position: "Adventure Seeker",
            text: "The trip to Khandala was fantastic! The ride was smooth, and the driver knew the area well, guiding us to the best spots. Mauli Cabs made the whole experience memorable.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Lonavala - Khandala Cab by Mauli Cabs",
        "description": "Mauli Cabs provides affordable and comfortable taxi service from Pune to Lonavala - Khandala. Choose from private, luxury, or group cabs for one-way or round-trip travel. Ideal for sightseeing and short getaways with 24x7 online booking.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "4200"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Lonavala - Khandala Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Lonavala - Khandala cab with Mauli Cabs. Affordable, comfortable taxis for sightseeing, one-way or round-trip travel. Private, group, and luxury options with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Lonavala - Khandala cab service, Book Pune to Lonavala - Khandala taxi, Affordable Pune to Lonavala - Khandala cab, Private taxi for Lonavala - Khandala from Pune, Lonavala - Khandala trip by cab from Pune, Pune to Lonavala - Khandala one-way or round trip, Lonavala - Khandala sightseeing by cab, Group travel to Lonavala - Khandala, Luxury taxi for Lonavala - Khandala trip, Comfortable taxi ride from Pune to Lonavala - Khandala"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavala;